import { render } from "./StatsWidgetTitle.vue?vue&type=template&id=080e5628&scoped=true"
import script from "./StatsWidgetTitle.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetTitle.vue?vue&type=script&lang=ts"

import "./StatsWidgetTitle.vue?vue&type=style&index=0&id=080e5628&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-080e5628"

export default script